import * as moment from "moment";
import * as React from "react";
import Player from "source/app/domain/Player";
import { LifeChangingEventCell } from "../LifeChangingEvents";
import { StyleClass } from "../../../Shared/Styles/CSS";

export function LifeChangingEventAge({ year }: { year: number }) {
    const age = year - moment(Player.birthday).year();

    const ageLabelClass = StyleClass(`LCEAgeLabel`, {
        fontSize: "8px",
        position: "relative",
        bottom: "4px",
        opacity: 0.4,
        right: `3px`,
    });

    const ageValueClass = StyleClass(`LCEAgeValue`, {
        opacity: 0.7,
        fontSize: `13px`,
    });

    return (
        <span>
            <span className={ageLabelClass}>age</span>
            <span className={ageValueClass}>{age}</span>
        </span>
    );
}
